import { Injectable } from '@angular/core';
import { ScrambleUnscrambleService } from '../Services/scramble-unscramble.service';
import { HttpServiceService } from '../Services/http-service.service';
import * as Rx from "rxjs";
import { DeviceDetectorService } from 'ngx-device-detector';
import { AlertService } from '../Services/alert.service';
import { Router, NavigationEnd } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

import { ScrambleUnscramblestring } from './scramble';

@Injectable({
  providedIn: 'root'
})
export class GlobalVariableService {

  // pagetitle;
  imagePath;
  // image;

  amc_code;
  amc_name;
  servicerequest:any;
  pathSrc: any;
  public usernameHeader = "";
  public rendataa;

  constructor(
    private __scrambleUnscrambleService: ScrambleUnscrambleService,
    private _httpService: HttpServiceService,
    private spinnerService: NgxSpinnerService,
    private detectorService: DeviceDetectorService, private router: Router,
    private alertService: AlertService,
    private ScrambleString: ScrambleUnscramblestring) { 
    };

  //public bhSubject = new Rx.BehaviorSubject(null);
  public itableSubject = new Rx.BehaviorSubject(null);
  public chartBhsubject = new Rx.BehaviorSubject(null);
  public profBhSubject = new Rx.BehaviorSubject(null);

  //public chartObservable = this.chartBhsubject.asObservable();

  IsLoggedIn: boolean = false;

  public pageTitle;
  public color;
  public bgColor;
  public borderColor;
  public activeMenu;
  public hvCard;
  public themeColor;
  public subfundCode;
  public folioNumber;
  public brColor;  
  public chartArray: any = [];

  public colorCode = {
    '0': '#1e59a9', '1': '#636363', '2': '#003557',
    '3': '#1E2D3B', '4': ' #008080', '5': '#003557',
    '6': ' #666', '7': '#5F7FBA', '8': '#E30613',
    '9': '#b0232f' ,'10': '#8faadc', '11': '#939598',
    '12': '#f18817 ','13': '#f18817 ', '15':'#CEAA31'
  };
  public brColorArray = {
 '10':'brColor10','13': 'brColor13'
  };

  public colorArr: any = [
    {
    '0': 'bg-col0', '1': 'bg-col1', '2': 'bg-col2',
    '3': 'bg-col3', '4': 'bg-col4', '5': 'bg-col5',
    '6': 'bg-col6', '7': 'bg-col7', '8': 'bg-col8',
    '9': 'bg-col9','10': 'bg-col10', '11': 'bg-col11','12': 'bg-col12','13': 'bg-col13 ','15':'bg-col15'
  },
  {
    '0': 'border-color00,border-color0', '1': 'border-color11,border-color1', '2': 'border-color22,border-color2',
    '3': 'border-color33,border-color3', '4': 'border-color44,border-color4', '5': 'border-color55,border-color5',
    '6': 'border-color66,border-color6', '7': 'border-color77,border-color7', '8': 'border-color88,border-color8',
     '9': 'border-color99,border-color9',  '10': 'border-color1010,border-color10',  '11': 'border-color1111,border-color111',
     '12': 'border-color120,border-color12','13': 'border-color130,border-color13',
     '15' : 'border-color1515,border-color15'
  },
  {
    '0': 'text-col0', '1': 'text-col1', '2': 'text-col2',
    '3': 'text-col3', '4': 'text-col4', '5': 'text-col5',
     '6': 'text-col6', '7': 'text-col7', '8': 'text-col8', '9': 'text-col9'
     , '10': 'text-col10', '11': 'text-col11','12':'text-col12','13':'text-col13','15':'text-col15'
  },
  {
    '0': 'active-menu0', '1': 'active-menu1', '2': 'active-menu2',
    '3': 'active-menu3', '4': 'active-menu4', '5': 'active-menu5'
    , '6': 'active-menu6', '7': 'active-menu7', '8': 'active-menu8', '9': 'active-menu9', '10': 'active-menu10', '11': 'active-menu11','12':'active-menu12','13':'active-menu13','15' : 'active-menu15'
  },
  {
    '0': 'hv-card0', '1': 'hv-card1', '2': 'hv-card2',
    '3': 'hv-card3', '4': 'hv-card4', '5': 'hv-card5'
    , '6': 'hv-card6', '7': 'hv-card7', '8': 'hv-card8', '9': 'hv-card9', '10': 'hv-card10', '11': 'hv-card11','12':'hv-card12','13':'hv-card13','15' : 'hv-card15'
  }];


  setThemeColorCodes() {
    let themeCode;
    let authid = sessionStorage.getItem("KrCGei");
    var sessionDetails = this.__scrambleUnscrambleService.pefundApplyInternalFilter("Unveil", sessionStorage.getItem("ZhJtE" + authid), this._httpService.scrambleKey);
    sessionDetails = JSON.parse(sessionDetails);
    if (sessionDetails) {
      themeCode = sessionDetails[0]["themeCode"];
    }

    if (themeCode) {
      this.bgColor = this.colorArr[0][themeCode];
      if(sessionDetails[0].amcname == "whiteoak"){
        this.activeMenu = this.colorArr[3][12];
        this.borderColor = this.colorArr[1][12];
        //console.log(this.hvCard)
      }else{

        this.activeMenu = this.colorArr[3][themeCode];
        this.borderColor = this.colorArr[1][themeCode];
        this.color = this.colorArr[2][themeCode];
        this.hvCard = this.colorArr[4][themeCode];
        this.themeColor = this.colorCode[themeCode];
      }

     
      
   
    }
  }

  lockUnlockConvert(data, key) {
    let Cloak = this.__scrambleUnscrambleService.pefundApplyInternalFilter("Cloak", JSON.stringify(data), key);
    return Cloak;
  }

  logout(pan, reason) {
    let panno = "";
    let email = "";
    let sessionid = "";

    let authid = sessionStorage.getItem("KrCGei");
    var sessionDetails = this.__scrambleUnscrambleService.pefundApplyInternalFilter("Unveil", sessionStorage.getItem("ZhJtE" + authid), this._httpService.scrambleKey);

    if (!(sessionDetails == null || sessionDetails == undefined)) {
      sessionDetails = JSON.parse(sessionDetails);
      panno = sessionDetails[0].pannumber;
      email = sessionDetails[0].email;
      sessionid = sessionDetails[0].sessionid;
    } else {
      panno = pan;
    } 
 
    let logoutDetails: any = {
      "flag": "LOG_OUT",
      "tax_no": panno,
      "email": email,
      "session_id": sessionid,
      "device_id":this.detectorService.getDeviceInfo().browser,
      "os_id": this.detectorService.getDeviceInfo().os + " - " + this.detectorService.getDeviceInfo().os_version,
      "amc_code": this.amc_code,
      // "recaptchatoken": a
    }
    this.spinnerService.show();
    this._httpService.logout(logoutDetails).subscribe((data) => {
      data = JSON.parse(this.__scrambleUnscrambleService.pefundApplyInternalFilter("Unveil", data, this._httpService.scrambleKey));
      if (data.status.errorflag == true) {
        this.alertService.errorMsg(data.status.errormsg);
        if (data.status.errormsg.includes("Session Expired")) {
          let authid = sessionStorage.getItem("KrCGei");
          sessionStorage.removeItem("ZhJtE" + authid);
          sessionStorage.removeItem("KrCGei");
          let name = this.amc_name
          this.router.navigate([name+'/login']);
        }
        this.spinnerService.hide();
        return;
      } else {
        sessionStorage.removeItem("ZhJtE" + authid);
        sessionStorage.removeItem("KrCGei");
        sessionStorage.tabCount = 0;

        if (reason == "clearsession") {
          this.spinnerService.hide();
          location.reload();
        } else if (reason == "timeout") {
          let name = this.amc_name
          this.router.navigate([name+'/login']);
          // this.router.navigate(['login']);
          this.spinnerService.hide();
          setTimeout(() => {
            alert("Session Expired!");
            //this.alertService.errorMsg("Session Expired!");
          }, 500);
        } else {
          let name = this.amc_name
          this.router.navigate([name+'/login']);
          setTimeout(() => {
            this.spinnerService.hide();
          }, 1000);
        }



      }

    });
  }

  // ---- idle code -- //

  // IsLogged(): boolean {
  //   return this.IsLoggedIn;
  // }

  // _authguard() {
  //   this.IsLoggedIn = true;
  // }

  //------ idle code --//

  setThemeColorCodesDP() {

    let themeCode;
    // var sessionDetails = JSON.parse(this.ScrambleString.ApplyInternalFilter("Unveil", sessionStorage.getItem('LoginDetails') || {}));
    var sessionDetails = sessionStorage.getItem('LoginDetails') || {};

    if (Object.keys(sessionDetails).length > 0) {
      sessionDetails = JSON.parse(this.ScrambleString.ApplyInternalFilter("Unveil", sessionDetails));
      themeCode = sessionDetails["themeCode"] || '';
    }

    if (themeCode) {
      this.bgColor = this.colorArr[0][themeCode];
      if (sessionDetails['amcname'] == "whiteoak") {
        this.activeMenu = this.colorArr[3][12];
        this.borderColor = this.colorArr[1][12];
      } else {
        this.activeMenu = this.colorArr[3][themeCode];
        this.borderColor = this.colorArr[1][themeCode];
        this.color = this.colorArr[2][themeCode];
        this.hvCard = this.colorArr[4][themeCode];
        this.themeColor = this.colorCode[themeCode];
        this.brColor = this.brColorArray[themeCode];
      }
    }
  }

}
